














import { Vue, Component, Prop } from "@/shared/vuepack";
import EmployerMonthlyReport from "./EmployerMonthlyReport.vue";
import { useBillingStore } from "@/shared/store/billing";

@Component({
  components: {
    EmployerMonthlyReport
  }
})

export default class PartnerBillingReport extends Vue {
  billingStore = useBillingStore();

  @Prop() employerId: number;

  get selectableBillingPeriods () { return this.billingStore.getSelectableBillingPeriods; }
  get periodsLoaded () { return this.billingStore.getMonthlyBillingPeriodsLoaded; }
  get loadBillingPeriodsByEmployer () { return this.billingStore.loadMonthlyBillingPeriodsByEmployer; }
  get resetBillingPeriodsState () { return this.billingStore.resetBilling; }
  get downloadReportForEmployer () { return this.billingStore.downloadEmployerReport; }
  get setPeriod () { return this.billingStore.setBillingPeriodId; }
}


